<template>
  <div class="app-wrapper">
    <el-container style="height: 100%">
      <el-header height="50px">
        <uk-header></uk-header>
      </el-header>
      <el-container style="height: 100%">
        <el-aside width="200px">
          <uk-menu></uk-menu>
        </el-aside>
        <el-main style="background: #F6F6F6">
          <div class="main-container">
            <uk-tab></uk-tab>
            <uk-tab-view></uk-tab-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { ukHeader, ukTab, ukMenu, ukTabView } from './components'

export default {
  name: 'layout',
  components: {
    ukHeader,
    ukTab,
    ukMenu,
    ukTabView
  }
}
</script>

<style scoped>
.app-wrapper {
  min-width: 1200px;
  height: 100%
}
.main-container {
  position: relative;
  height: 100%;
}
</style>
